import { api } from '../api';
import { stopAllChatStreams } from '../hooks/useChatStream';
import { unsubscribeThisDevice } from '../push';
import { useDrafts } from '../stores/drafts';

/** Signs out from the account menu (desktop) or from Settings (phone). */
export async function signOut(userId: string): Promise<void> {
  stopAllChatStreams();
  useDrafts.getState().clear();
  // Stop notifying this device for the person who signs out (bounded: offline must not block).
  await Promise.race([
    unsubscribeThisDevice(userId).catch(() => {}),
    new Promise((resolve) => window.setTimeout(resolve, 3000)),
  ]);
  await api.logout().catch(() => {});
  window.location.href = '/login';
}
